import {
  useNavigate as useRouterNavigate,
  NavigateOptions,
  useParams,
} from 'react-router-dom'

export function useNavigate() {
  const navigate = useRouterNavigate()
  const { lang } = useParams<{ lang: string }>()

  return (to: StrOrNum, options?: NavigateOptions) => {
    if (typeof to === 'number') {
      return navigate(to)
    }

    if (to.startsWith('/')) {
      const langPrefix = lang || 'en'
      const pathWithLang = `/${langPrefix}${to}`
      return navigate(pathWithLang, options)
    }

    return navigate(to, options)
  }
}
